<template>
  <div>
    <div class="ui stacked blue segment" ref="trgtVue">
      <!-- <vue-editor v-model="dummy" class="hidden"></vue-editor> -->
    </div>
  </div>
</template>

<script>
// import { local_api, error_toast } from "@/utils";
// import { clone } from "@/utils";
import filters from "@/filters";
import moment from "moment";
import Vue from "vue";
// import { VueEditor } from "vue2-editor";
// import _ from "lodash";

export default {
  name: "ReceiptModalReceipt",
  filters: filters,
  components: {
    // VueEditor,
  },
  // props: {
  //   receipt_data: Object,
  //   template_in: Object,
  // },
  data() {
    return {
      // dummy: "",
      vueInstance: undefined,
    };
  },
  computed: {},
  methods: {
    setConfig(config) {
      let vm = this;
      if (config.template && config.template.template && config.info) {
        let html_template = config.template.template.html;
        let css = config.template.template.css;
        let trgt = vm.$refs.trgtVue;
        try {
          let mixin = {};
          if (config.template.template.js) {
            eval(`mixin = ${config.template.template.js}`);
          }

          vm.vueInstance = new Vue({
            el: trgt,
            mixins: [mixin],
            data() {
              return {
                student: config.info.std_student,
                inscription: config.info,
              };
            },
            methods: {
              moment: moment,
              decodeGender(gender) {
                if (gender.toLowerCase() == "m") return vm.$t("male");
                else if (gender.toLowerCase() == "f") return vm.$t("female");
                else return `[${status}]`;
              },
              decodeCivilStatus(status) {
                if (status.toLowerCase() == "m") return vm.$t("married");
                else if (status.toLowerCase() == "s") return vm.$t("single");
                else return `[${status}]`;
              },
              calculateAge(birthdate) {
                let r = moment().diff(moment(birthdate), "years");
                return r;
              },
            },
            template: html_template,
            mounted() {
              setTimeout(() => {
                window.jQuery(vm.$el).append(`<style>${css}</style>`);
              }, 200);
            },
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>

<style></style>
